<template>
  <div class="w-full md:w-auto mt-3 md:mt-0" id="containerSearchQuotes">
    <span class="text-sm font-semibold text-blue-500 pb-2 block">
      Cotización
    </span>
    <div class="relative md:min-w-[260px] lg:min-w-[320px]">
      <div class="flex items-center relative text-gray-600">
        <div class="absolute top-0 left-3 w-6 h-full flex items-center">
          <font-awesome-icon icon="fa-solid fa-search" class="w-4 h-4" />
        </div>
        <input
          type="search"
          v-model="dataForm.searchInput"
          class="border-2 pl-9 py-2 text-sm outline-none w-full rounded-md bg-gray-50 focus:border-blue-500"
          placeholder="Buscar por nombre de cliente o n° de documento"
          @keydown.enter="getData"
          @input="getData"
          @keydown.enter.prevent
          autocomplete="off"
        />
      </div>
      <div
        v-if="showQuotes"
        class="absolute top-[2.4rem] left-0 right-0 z-10 py-2 bg-white border border-gray-300 rounded-md shadow-lg max-h-72 overflow-y-auto"
      >
        <div v-if="loadingSearch">
          <div class="px-3">
            <div
              class="px-3 py-3 bg-gray-200 animate-pulse rounded-lg mb-2"
            ></div>
            <div
              class="px-3 py-3 bg-gray-200 animate-pulse rounded-lg mb-2"
            ></div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="!dataLength"
            class="px-3 py-1 bg-gray-50 text-gray-400"
            @click="showQuotes = false"
          >
            <strong>{{ dataForm.searchInput }}</strong> no existe en nuestra
            base de datos
          </div>
          <div
            v-else
            v-for="(result, i) in dataResult"
            :key="i"
            class="odd:bg-white even:bg-slate-50"
            @blur="showQuotes = false"
          >
            <div
              class="py-2 px-3 pb-1 text-gray-600 cursor-pointer text-sm hover:bg-gray-100 hover:text-blue-500 uppercase"
              @click="
                addOrder(
                  {
                    id: result.id,
                    idCustomer: result.idcliente,
                    nameCustomer: result.nombre_cliente,
                    comentary: result.comentarios,
                    userName: result.usuario.nombres,
                    idVoucher: result.idcomprobante,
                  },
                  result.detalle,
                  result.validez_cotizacion
                )
              "
            >
              {{ result.nombre_cliente }}
              <div>
                <span
                  class="px-3 py-1 rounded-md text-orange-500 bg-orange-50 text-xs font-semibold"
                >
                  {{ money() }} {{ format(result.total) }}
                </span>
                <span
                  class="px-3 py-1 rounded-md text-orange-500 bg-orange-50 text-xs font-semibold"
                >
                  {{
                    result.validez_cotizacion !== null
                      ? calculateExpirationDate(
                          result.validez_cotizacion.slice(0, 10)
                        )
                      : null
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorActions } from "@/alerts";
import axios from "@/api";
import { onMounted, onUnmounted, ref } from "vue";
import { observeElement } from "@/observer";
import { idLocalStore } from "@/publicjs/localStorage";
import { money, format } from "@/publicjs/money";
import { calculateExpirationDate } from "@/publicjs/calculateProductExpiration";
import Swal from "sweetalert2";
export default {
  name: "SearchQuotes",
  emits: ["send-data"],
  setup(_, { emit }) {
    const dataForm = ref({
      idStore: 0,
      searchInput: "",
    });

    const infoOrder = ref({
      id: 0,
      idCustomer: 0,
      idVoucher: 0,
      nameCustomer: "",
      comentary: "",
      detailOrder: [],
      userName: "",
    });

    //Funcion para cargar las cotizaciones
    const showQuotes = ref(false);
    const loadingSearch = ref(true);
    const dataResult = ref([]);
    const dataLength = ref(false);
    const getData = async () => {
      try {
        loadingSearch.value = true;
        showQuotes.value = true;
        dataLength.value = false;
        const response = await axios
          .get(
            `cotizacion/?page=1&per_page=20&search=${dataForm.value.searchInput}&idstore=${dataForm.value.idStore}&state=VIGENTE`
          )
          .catch((error) => errorActions(error));
        dataResult.value = await response.data.data;
        if (dataResult.value.length > 0) {
          dataLength.value = true;
        }
        loadingSearch.value = false;
      } catch (error) {
        errorActions(
          "Upsss. No pudimos encontrar la cotización debido a que hemos tenido unos inconvenientes"
        );
      }
    };

    onMounted(async () => {
      observeElement("#containerSearchQuotes");
      window.addEventListener("keydown", handleKeyDown);
      dataForm.value.idStore = await idLocalStore();
      await getData();
    });
    onUnmounted(() => {
      window.removeEventListener("keydown", handleKeyDown);
    });
    /*******************************************************************************************
     * Funcion para cerrar resultado de busqueda de la cotizacion
     *******************************************************************************************/
    const handleKeyDown = async (event) => {
      if (event.keyCode === 27) {
        showQuotes.value = false;
      }
    };

    /*******************************************************************************************
     * Funcion para agregar la orden a la venta
     *******************************************************************************************/
    const addOrder = async (data, details, expired) => {
      //Validamos que la cotización no esté vencido
      if (expired !== null) {
        if (calculateExpirationDate(expired.slice(0, 10)) === "VENCIDO") {
          errorActions(
            "Le sentimos <strong>la cotización a caducado</strong> no podemos agregar a la lista de ventas"
          );
          return;
        }
      }
      await Swal.fire({
        title: "¿Seguro que deseas usar la cotización?",
        html: `Por favor verifica que <strong>los productos agregados a la cotización cuenten con el stock suficiente</strong>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#315df5",
        cancelButtonColor: "#dc2626",
        confirmButtonText: "Si, usar.",
        cancelButtonText: "Cancelar",
        width: "300px",
      }).then((result) => {
        if (result.isConfirmed) {
          const {
            id,
            idCustomer,
            nameCustomer,
            comentary,
            userName,
            idVoucher,
          } = data;
          infoOrder.value.id = id;
          infoOrder.value.idCustomer = idCustomer;
          infoOrder.value.nameCustomer = nameCustomer;
          infoOrder.value.comentary = comentary;
          infoOrder.value.userName = userName;
          infoOrder.value.idVoucher = idVoucher;

          // Recorrer el arreglo de detalles y convertir solo el campo "unidades" a un objeto JavaScript válido
          const parsedDetails = details.map((detail) => {
            const parseUnits = JSON.parse(detail.units);
            // return { ...detail, units: parseDatils };
            const parsedDetail = { ...detail, units: parseUnits };

            // Convertir los valores numéricos a números
            parsedDetail.discount = parseInt(parsedDetail.discount);
            parsedDetail.idProduct = parseInt(parsedDetail.idProduct);
            parsedDetail.igvApplied = parseInt(parsedDetail.igvApplied);
            parsedDetail.igv = parseFloat(parsedDetail.igv);
            parsedDetail.insuranceDiscount = parseInt(
              parsedDetail.insuranceDiscount
            );
            parsedDetail.maximumDiscount = parseInt(
              parsedDetail.maximumDiscount
            );
            parsedDetail.quantity = parseFloat(parsedDetail.quantity);
            parsedDetail.quantityContained = parseFloat(
              parsedDetail.quantityContained
            );
            parsedDetail.salePrice = parseFloat(parsedDetail.salePrice);
            parsedDetail.subTotal = parseFloat(parsedDetail.subTotal);
            parsedDetail.total = parseFloat(parsedDetail.total);
            parsedDetail.shoppingPrice = parseFloat(parsedDetail.shoppingPrice);

            return parsedDetail;
          });

          infoOrder.value.detailOrder = parsedDetails;

          emit("send-data", infoOrder.value);

          showQuotes.value = false;
        }
      });
    };

    return {
      showQuotes,
      loadingSearch,
      dataResult,
      dataLength,
      getData,
      dataForm,
      money,
      format,
      addOrder,
      calculateExpirationDate,
    };
  },
};
</script>
